<template>
  <div class="tariff-container">
    <div class="tariff-header">
      <h1>Цены</h1>
    </div>
    <div class="tariff-content">
      <div class="tariff-content__item" v-for="tariff in tariffs" :key="tariff.id">
        <div class="tariff-content__item__name">{{tariff.name}} {{tariff.name_second}}</div>
        <div class="tariff-content__item__price">{{tariff.price}} ₽/л</div>
      </div>
      <div class="tariff-delivery">
        <div class="tariff-delivery__main">
          <div class="tariff-delivery__main__title">Доставка*</div>
          <div class="tariff-delivery__main__price">199 ₽</div>
        </div>
         <div class="tariff-delivery__description">
           *Точную стоимость доставки
           уточняйте у оператора по телефону
         </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "ModalTariff",
  props: {
    tariffs: {
      type: Array,
    },
  },
}
</script>

<style scoped lang="scss">
@import "../assets/scss/mixins/mixins";
.tariff-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  .tariff-delivery {
    @include breakpoint(sm) {
      &__main, &__description {
        padding: 0 50px;
      }
    }
    &__main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__title {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #434040;
      }
      &__price{
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #434040;
      }
    }
    &__description {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.01em;

      color: #64656A
    }
  }
  .tariff-header {
    h1 {
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      letter-spacing: 0.01em;

      color: #434040;
    }
  }
  .tariff-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
    @include breakpoint(sm) {
      &__item {
        padding: 0 50px;
      }
    }
    &__item {
      min-width: 360px;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #434040;
      display: flex;
      justify-content: space-between;
      &__price {
        min-width: 65px;
      }
    }
  }
}
</style>
